import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getStripeConfig, PutStripeBody, putStripeConfig } from '../../../api/admin/paymentProviders.api';
import { selectCollAndDeliveryPointID } from '../../../auth/selectors/authSelectors';
import FormCard from '../../../components/Core/FormCard/FormCard';
import { TOAST_SEVERITY } from '../../../components/Core/Toast/Toast';
import { useSnackbar } from '../../../context/SnackbarContext';
import useBuildForm from '../../../hook/useBuildForm';
import { stripeForm } from './providers.forms';

function StripeFormCard() {
  const snackbar = useSnackbar();
  const { t } = useTranslation('admin/paymentProviders');
  const { id_coll } = useSelector(selectCollAndDeliveryPointID);
  const { mutate: putConfig, isLoading } = useMutation(
    ['put.paymentProvider.stripe'],
    (data: Omit<PutStripeBody, 'id_coll'>) => putStripeConfig({ id_coll, ...data }),
    {
      onSuccess: () => {
        snackbar?.setAlert({ message: 'success', severity: TOAST_SEVERITY.success });
      },
    }
  );
  const { data: config } = useQuery(
    ['get.paymentProvider.stripe', id_coll],
    ({ queryKey }) => {
      const [, id_coll] = queryKey;
      return getStripeConfig(id_coll as number);
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 40000_000,
    }
  );
  const { builtFormFields, handleSubmit } = useBuildForm({ formObject: stripeForm(t), defaultValues: config?.data });

  const onSubmit = useCallback(
    handleSubmit(async (data) => {
      putConfig(data as Omit<PutStripeBody, 'id_coll'>);
    }),
    []
  );

  return (
    <FormCard title={t('stripe.stripe_title')} isLoading={isLoading} onSubmit={onSubmit}>
      {builtFormFields}
    </FormCard>
  );
}

export default StripeFormCard;
